export default __webpack_public_path__ + "static/media/uploader-oneTouchVerioIQ-problem-2.b9b1ae1b.png";